import { render, staticRenderFns } from "./OrderAdditionalCostSettings.vue?vue&type=template&id=07dea231&scoped=true&"
import script from "./OrderAdditionalCostSettings.vue?vue&type=script&lang=js&"
export * from "./OrderAdditionalCostSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dea231",
  null
  
)

export default component.exports